import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { routeGenerator } from 'routes';
import { actionRoleListByUser } from 'Root/http';
import RoleSelector from 'Root/pages/shared/RoleSelector';

import RoleItem from './RoleItem';

import s from './style/Roles.pcss';


@withRouter
export default class Roles extends React.Component {
  static propTypes = {
    roles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    onRoleSelect: PropTypes.func.isRequired,
    updateRoles: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
    match: PropTypes.shape().isRequired,
  };

  state = {
    addMode: false,
    saving: false,
  };

  onSetAddMode = addMode => this.setState({ addMode });
  updateRoles = data => this.props.updateRoles(data.roleArray);

  onRoleRemove = (roleId) => {
    const { match } = this.props;
    const userId = match.params.userId;
    this.setState({ saving: true }, () => {
      actionRoleListByUser(userId, roleId, false)
        .then(this.updateRoles)
        .then(() => this.setState({ saving: false }));
    });
  };
  onRoleEdit = roleId =>
    this.props.history.push(routeGenerator.roleEditLink(roleId));

  onAddRole = roleId =>
    actionRoleListByUser(this.props.match.params.userId, roleId, true).then(this.updateRoles);

  render() {
    const { addMode, saving } = this.state;
    return (
      <div className={s.roles}>
        <div className={s.list}>
          {this.props.roles.map(role => (
            <RoleItem
              key={role.id}
              item={role}
              saving={saving}
              selected={role.id === this.props.match.params.roleId}
              onRoleSelect={this.props.onRoleSelect}
              onRoleRemove={this.onRoleRemove}
              onRoleEdit={this.onRoleEdit}
            />
          ))}
        </div>
        <RoleSelector
          existRoles={this.props.roles.map(r => r.id)}
          onVisible={this.onSetAddMode}
          onAddRole={this.onAddRole}
          visible={addMode}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Users/UserPage/Roles/Roles.js